import { SortField } from '../../generic-overview/components/display-settings-bar/entities/sort-field.entity';
import { SortOption } from '../../generic-overview/components/display-settings-bar/entities/sort-option.entity';

// MED-5618: Convert SortFields using DottedKey to map correctly to default sort options
export function fieldSortOptionToDefaultSortOption(defaultSort: SortOption): SortOption {
    return {
        ...defaultSort,
        field: fieldKeyToDefaultSortOptionKey(defaultSort.field)
    };
}

export function fieldKeyToDefaultSortOptionKey(field: string): string {
    let sortKey: string;

    switch (field) {
        case 'Administrative.LastModifiedDate':
            sortKey = SortField.LAST_MODIFIED_DATE;
            break;

        case 'Administrative.ArchiveDate':
            sortKey = SortField.ARCHIVE_DATE;
            break;

        case 'Administrative.PublicationDate':
            sortKey = SortField.PUBLICATION_DATE;
            break;

        case 'Descriptive.CreationDate':
            sortKey = SortField.CREATION_DATE;
            break;

        case 'Descriptive.Title':
            sortKey = SortField.TITLE;
            break;

        case 'Descriptive.OriginalFilename':
            sortKey = SortField.ORIGINAL_FILENAME;
            break;

        default:
            sortKey = field;
    }

    return sortKey;
}
